var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VuePlyr',{staticClass:"plyr__video-embed",attrs:{"options":_vm.options}},[_c('div',[_c('iframe',{attrs:{"src":"https://youtu.be/JPyMDA6IW5g","allowtransparencys":"","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04071058","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guideQuery.vue
// module id = null
// module chunks = 